import Vue from 'vue'
import helpers from '../utils/helpers'

export default {
    install () {
        Vue.prototype.$helpers = helpers
    }
}
